/**
 * Tồn đọng AC (04/10/2026) — thay khẳng định non-null `x!` (Biome `noNonNullAssertion`) ở chỗ BẤT BIẾN đã được bảo đảm
 * (query chỉ chạy khi `enabled: !!id`, nhánh hiển thị đã kiểm trường, phần tử mảng đã kiểm độ dài…).
 * Khác `!`: nếu bất biến bị phá thì ném Error nêu rõ thiếu gì, thay vì để `undefined` lọt xuống URL API / DOM.
 * Khi `null`/`undefined` là trạng thái HỢP LỆ thì dùng `?.` / `??` / guard sớm — không dùng `must`.
 */
export function must<T>(value: T | null | undefined, what: string): T {
  if (value === null || value === undefined) throw new Error(`Bất biến bị vi phạm: thiếu ${what}`);
  return value;
}
